<div class="font-semibold" [innerHTML]="label"></div>
<div class="truncate">
  <ng-content></ng-content>
</div>
